
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
#chart-container{
  width:100%;
  height:100%;
}

.subtitle{
  font-weight:bold;
}

.subtitle .target{
    padding-left:40px;
    color:red;
  }

.subtitle .target::before{
      content:"-----";
    }

.subtitle .line{
    color:#0573ae;
    padding-left:40px;
    position:relative;
  }

.subtitle .line::before{
      content:"";
      background-color:#0573ae;
      width:19px;
      height:1px;
      position:absolute;
      top:50%;
      left:20px;
      font-size:var(--fs-base);
    }`;